<app-panel-header-image-view pretitle="Calendar" title="Competitions" [banner_image]="banner"></app-panel-header-image-view>

<app-app-content-page-wrapper>
  <router-outlet></router-outlet>

</app-app-content-page-wrapper>
